import { GetInstallmentsParams, reportsService } from '@/services';
import { downloadBlob, filenameFromResponse } from '@/shared/utils/download-blob.util';
import { useMutation } from '@tanstack/react-query';

/**
 * Exporta o Extrato de Parcelas da busca atual para Excel e dispara o download.
 * Em falha, lança a mensagem para a tela exibir o aviso de erro de exportação.
 */
export function useInstallmentsExport() {
  return useMutation({
    mutationFn: async (params: GetInstallmentsParams) => {
      const response = await reportsService.exportInstallments(params);
      if (!response.ok) {
        throw new Error(
          'Não foi possível exportar o extrato de parcelas no momento. Tente novamente mais tarde.'
        );
      }
      const blob = await response.blob();
      const filename = filenameFromResponse(response, 'extrato-parcelas.xlsx');
      downloadBlob(blob, filename);
      return filename;
    },
  });
}
